import api from './client';

export interface ApiUser {
  id: number;
  username: string;
  role: string;
  is_active: boolean;
  created_at: string;
}

export interface UserCreateData {
  username: string;
  password: string;
  role: string;
}

export interface UserUpdateData {
  password?: string;
  role?: string;
  is_active?: boolean;
}

export const listUsers = async (): Promise<ApiUser[]> => {
  const response = await api.get('/users');
  return response.data;
};

export const createUser = async (data: UserCreateData): Promise<ApiUser> => {
  const response = await api.post('/users', data);
  return response.data;
};

export const updateUser = async (userId: number, data: UserUpdateData): Promise<ApiUser> => {
  const response = await api.put(`/users/${userId}`, data);
  return response.data;
};

export const deleteUser = async (userId: number): Promise<void> => {
  await api.delete(`/users/${userId}`);
};
